(function(){
  var validCodes = ['GS-7842XK','GS-3914MZ','GS-5621AW'];
  var input = document.getElementById('gsp-code');
  var btn = document.getElementById('gsp-verify');
  var result = document.getElementById('gsp-result');
  if (!btn) return;
  function verify() {
    var code = (input.value || '').trim().toUpperCase();
    if (code.indexOf('GS-') !== 0 && code.length === 6) code = 'GS-' + code;
    input.value = code;
    if (!code) { result.className = 'fail'; result.innerHTML = '<strong>Please enter a code.</strong> Format: GS-XXXXXX'; return; }
    if (validCodes.indexOf(code) !== -1) {
      result.className = 'success';
      result.innerHTML = '<strong>Verified Golden SNIP.</strong><br>Code <strong>' + code + '</strong> is authentic.<br><br>Email golden@catchthesnip.com with your unboxing video for $10,000 USD claim.';
    } else {
      result.className = 'fail';
      result.innerHTML = '<strong>Code not recognized.</strong><br>' + code + ' does not match any Golden SNIP in our database.';
    }
  }
  btn.addEventListener('click', verify);
  input.addEventListener('keydown', function(e){ if (e.key === 'Enter') verify(); });
})();